import {RowContextAction} from '@/incoming-balance/types/RowContextAction.type'
import {CsvDataRow} from '@/incoming-balance/types/CsvDataRow.type'
import useTrialBalance from '@/incoming-balance/tribal.composable'
import {fetchBookkeepingAccount} from '@/bookkeeping-account/bookkeepingAccount.service'

const trialBalance = useTrialBalance()

const { createAccount, correctMisnamedAccount, activateAccount, correctMismatchedVatCode } = useTrialBalance()

export const getAccountRowActions = (row: CsvDataRow): RowContextAction[] => {
    const actions: RowContextAction[] = []
    const isMissing = trialBalance.isAccountMissing(row)
    const isMisnamed = trialBalance.isAccountMisnamed(row)
    const isInactive = trialBalance.accountNeedsActivation(row)
    const isVatMismatch = trialBalance.isVatMismatch(row)

    if (isMissing) {
        actions.push({
            name: 'Opprett konto',
            icon: '<i class="i-ph-plus inline-block align-middle"/>',
            action: () => createAccount(row)
        })
    }

    if (isMisnamed) {
        actions.push({
            name: 'Endre navn på konto i systemet',
            icon: '<i class="i-ph-pencil inline-block align-middle"/>',
            action: () => correctMisnamed(row)
        })
    }

    if (isInactive) {
        actions.push({
            name: 'Aktiver konto',
            icon: '<i class="i-ph-check inline-block align-middle"/>',
            action: () => activate(row)
        })
    }

    if (isVatMismatch) {
        actions.push({
            name: 'Endre MVA-kode på konto i systemet',
            icon: '<i class="i-ph-pencil inline-block align-middle"/>',
            action: () => correctMisnamedVat(row)
        })
    }

    return actions
}

const correctMisnamed = async (row: CsvDataRow) => {
    await correctMisnamedAccount(row)
    await fetchBookkeepingAccount()
}

const activate = async (row: CsvDataRow) => {
    await activateAccount(row)
    await fetchBookkeepingAccount()
}

const correctMisnamedVat = async (row: CsvDataRow) => {
    await correctMismatchedVatCode(row)
    await fetchBookkeepingAccount()
}